var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"visibility":"hidden","opacity":"0"},attrs:{"id":"dropzone"}},[_c('div',{attrs:{"id":"textnode"}},[_vm._v("Glisser/déposer des fichiers.")])])
}]

export { render, staticRenderFns }